export default "__VITE_ASSET__Chzrp4iZ__"